export default __webpack_public_path__ + "static/media/640_private03-es-web.9896bf4c.png";